import React, { Component } from 'react';

class Paragraph extends Component {
  render() {
    const { text } = this.props;

    if (!text) return null;

    return (
      <React.Fragment>
        {/* NOTE: double backslash only, because thats how they get returned from db */}
        {text.split("\n\n").map((paragraph, i) => {
          return (
            <p key={`para-${i}`}>
              {paragraph.split("\n").map((line, j) => {
                return (
                  <React.Fragment key={`line-${j}`}>
                    {line}
                    <br />
                  </React.Fragment>
                );
              })}
            </p>
          );
        })}
      </React.Fragment>
    );
  }
}

export default Paragraph;